export function getMapBoxSelections(item) {
  item = typeof item === 'string' ? JSON.parse(item) : item
  if (!item || typeof item.place_type === 'undefined') return undefined;
  let contextValues = {};

  item.context.forEach(element => {
    contextValues[element.id.split('.')[0]] = element.text
  });

  let retVal = {
    ... contextValues,
    address: item.place_name,
    placeType: item.place_type,
    latitude: item.geometry.coordinates[1],
    longitude: item.geometry.coordinates[0]
  }

  if (item.place_type.includes('address')) {
    retVal.placeType = 'address'
  } else if (item.place_type.includes('place')) {
    retVal.placeType = 'place'
  }

  return retVal
}